import styled from "styled-components"
import theme from 'common/theme'

export const ButtonWithDropdownContainer = styled.div`
  position: relative;
  display: flex;
 
  z-index: 1;
  font-size: .9em;
  
  .hover-area {
    width: 2em;
    height: 2em;
    background: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: solid 1px transparent;
    border-radius: 5px;
    display: block;
  }
   
  .dropdown-wrapper {
    top: 100%;
    right: 0;
    display: none;
    position: absolute;
    flex-direction: column;
    background-color: white;
    box-shadow: ${theme.effects.boxShadow.main};
    border-radius: 0 0 5px 5px;
    overflow: hidden;
    
    .dropdown-spacer { 
      border-bottom: solid 1px ${theme.colors.gray300};
      padding: .5em;
      font-weight: 600;
       text-transform: capitalize;
    }

    button { 
     text-transform: capitalize;
      display: grid;
      width: 100%;
      min-width: max-content;
      grid-template-columns: 1em 1fr;
      cursor: pointer;
      background: transparent;
      border-color: transparent;
      font-size: .9em;
      font-family: inherit;
      gap: .5em;
      padding: .5em;
      text-align: left;

      &[disabled] .icon--setting path {
        stroke: ${theme.colors.gray400};
      }

      .icon {
        width: 1em;
        height: auto;
      }

      .is-selected,
      &:hover {
        background-color: ${theme.colors.gray200};
      }

    }

    &:hover { display: block; }

  }

  &:hover {
    z-index: 100;
    .dropdown-wrapper { display: flex; }
    .hover-area { 
      border-color: ${theme.colors.jbtBlue};
     }
    background-color: ${theme.colors.gray200};
  }

  button: hover {
    background-color: ${theme.colors.gray200};
  }


`